// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202601231334/js/" + chunkId + "." + {"44":"f296733a","225":"6992235f","481":"8c61903d","486":"6bffddea","770":"9be5e822"}[chunkId] + ".0.03514868721250708.chunk.js";
};